<template>
  <div class="container">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="内容关键字">
        <el-input
          v-model="formInline.content"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="上报时间">
        <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="dateChange"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
    <el-button
      type="primary"
      size="mini"
      style="margin-bottom: 20px"
      @click="dialogFormVisible = true"
      v-if="isShow"
      >新增</el-button
    >
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      height="500px"
      v-loading="loading"
    >
      <el-table-column
        type="index"
        width="50"
        label="序号"
        align="center"
        :index="indexMethod"
      >
      </el-table-column>
      <el-table-column prop="title" label="舆情标题" width="180" align="center">
      </el-table-column>
      <el-table-column
        prop="source"
        label="内容来源"
        width="180"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="link" label="网址" align="center">
        <template slot-scope="scope">
          <div>
            <el-link type="primary" @click="hrefHanler(scope.row.link)">{{
              scope.row.link
            }}</el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="主要内容摘要" align="center">
      </el-table-column>
      <el-table-column prop="createTime" label="上报时间" align="center">
      </el-table-column>
    </el-table>
    <div ref="page">
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="formInline.pageNo"
        :limit.sync="formInline.pageSize"
        @pagination="getList"
      />
    </div>
    <el-dialog :visible.sync="dialogFormVisible" width="35%">
      <el-form :model="form">
        <el-form-item label="舆情标题：" :label-width="formLabelWidth">
          <el-input
            v-model="form.title"
            autocomplete="off"
            placeholder="请填写"
          ></el-input>
        </el-form-item>
        <el-form-item label="内容来源：" :label-width="formLabelWidth">
          <el-input
            v-model="form.source"
            autocomplete="off"
            placeholder="请填写来源网址名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="网址：" :label-width="formLabelWidth">
          <el-input
            v-model="form.link"
            autocomplete="off"
            placeholder="请填写舆情信息网址"
          ></el-input>
        </el-form-item>
        <el-form-item label="内容摘要：" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="form.content"
            maxlength="300"
            show-word-limit
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">上 报</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getOpinionList, addOpinion } from "@/api/api.js";
export default {
  name: "",
  data() {
    return {
      formInline: {
        pageNo: 1,
        pageSize: 10,
        content: "",
        dateRange: "",
      },
      loading: false,
      date: "",
      tableData: [],
      total: 1,
      dialogFormVisible: false,
      form: {
        content: "",
        link: "",
        source: "",
        title: "",
        dateRange: 1,
        status: 0,
        typeName: "科研诚信",
        type: "1552961919232540673",
      },
      formLabelWidth: "85px",
      userName: "admin",
      isShow: false,
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  mounted() {
    let user = JSON.parse(sessionStorage.getItem("user"));
    if (user) {
      if (this.userName == user.username) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    }
  },
  methods: {
    indexMethod(index) {
      return (
        (this.formInline.pageNo - 1) * this.formInline.pageSize + index + 1
      );
    },
    search() {
      this.formInline.pageNo = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      getOpinionList(this.formInline).then((res) => {
        // console.log(res.data);
        this.loading = false;
        this.tableData = res.data.data.rows;
        this.total = res.data.data.totalRows;
      });
    },
    dateChange(e) {
      if (e) {
        this.formInline.dateRange = e[0] + "_" + e[1];
      } else {
        this.formInline.dateRange = "";
      }
    },
    hrefHanler(url) {
      window.open("http://" + url, "_blank");
    },
    submit() {
      addOpinion(this.form).then((res) => {
        console.log(res.data);
        if (res.data.code != 200) {
          this.$message.error(res.data.message);
        } else {
          this.$message.success("上报成功");
          this.dialogFormVisible = false;
          this.search();
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  background: #fff;
  margin: 0;
  padding: 20px;
  box-sizing: border-box;
  min-height: 700px;
  position: relative;
}
::v-deep .pagination-container .el-pagination {
  right: 10px;
  position: absolute;
  bottom: 10px;
}
::v-deep .el-date-editor .el-range-separator {
  padding: 0 !important;
}
</style>
